import { Injectable } from '@angular/core';
import { ToasterService } from '../../shared/toaster.service';
import { environment } from '../../../environments/environment';
import { StorageService, LocalStorageKey } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class CasheService {

  constructor(
    private _ToasterService: ToasterService,
    private storage: StorageService
  ) {}

  async checkVersion(): Promise<void> {
    let currentVersion: string | undefined;
    try {
      const response = await fetch('assets/version.json', { cache: 'no-store' });
      const data = await response.json();
      currentVersion = data?.version;
    } catch {
      // If version.json fetch fails, skip version check entirely
      return;
    }

    // If version.json has no valid version value, skip to avoid infinite reloads
    if (!currentVersion) {
      return;
    }

    const storedVersion = this.storage.getLocal(LocalStorageKey.AppVersion);

    if (!storedVersion) {
      this.clearClientState();
      this.storage.setLocal(LocalStorageKey.AppVersion, currentVersion);
      window.location.reload();
      return;
    }

    // Only reload when the stored version truly differs from the server version
    if (storedVersion === currentVersion) {
      return;
    }

    this.clearClientState();
    this.storage.setLocal(LocalStorageKey.AppVersion, currentVersion);
    window.location.reload();
  }

  private clearClientState(): void {
    // Only preserve AppVersion (it will be re-set immediately after)
    this.storage.clearLocal([LocalStorageKey.AppVersion]);
    this.storage.clearSession();

    if ('caches' in window) {
      caches.keys().then(names => {
        names.forEach(name => caches.delete(name));
      });
    }
  }
}
